module.exports = __webpack_public_path__ + "static/img/app.5c399a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/app.jpg
// module id = HRvL
// module chunks = 20